import { useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import SEO from "@components/seo";
import MainContent from "@components/content";
import ContainerMini from "@components/containerMini";
import * as Types from '../../types';
import useUserData from "@hooks/useUserData";
import { toast } from "sonner";

import Logo from '@assets/images/logoMini.svg';
import TinyMceEditor from "@pages/admin/blog/editor";

export default function Ticket() {
  let { id } = useParams();
  const { userData } = useUserData();
  const [ticket, setTicket] = useState<Types.Ticket | null>();
  const [updated, setUpdated] = useState<boolean>(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (updated === false) return;
    axios.get(`${import.meta.env.VITE_API_URL}/support/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      }
      })
      .then(response  => {
        setTicket(response.data);
        setUpdated(false);
      })
      .catch(_ => {
        setTicket(null);
    });
  }, [updated]);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append('msg', message);
    
    axios.post(`${import.meta.env.VITE_API_URL}/support/${ticket?.id}`, formData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      }})
      .then(async (response) => {
        setUpdated(true);
        toast.success('Сообщение отправлено');
      });
  };

  function convertToDate(isoDate: any) {
    const date = new Date(isoDate);
    const options: any = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Intl.DateTimeFormat('ru-Ru', options).format(date);
  }

  return (
    <MainContent>    
      <SEO 
        title="Поддержка"
        description=""
        ogUrl="https://artcons.io/"
      />

      <div className={css.headTicket}>
        <Link to={`/support`} className={css.back}><i className="fi fi-rr-arrow-small-left"></i> Вернуться</Link>
        <h1>
          <div><a className={css.type}>{ticket?.type === 0 && "Вопрос"} {ticket?.type === 1 && "Проблема"} {ticket?.type === 2 && "Квоты"}</a> {ticket?.topic}</div>
          {ticket?.status === 0 && <a className={css.status} style={{ background: "#0f4dca40" }}><i className="fi fi-rr-time-oclock"></i> На рассмотрении</a>}
          {ticket?.status === 1 && <a className={css.status} style={{ background: "#cab40f40" }}><i className="fi fi-rr-envelope"></i> Есть ответ</a>}
          {ticket?.status === 2 && <a className={css.status} style={{ background: "#33b07454" }}><i className="fi fi-rr-check-circle"></i> Решили</a>}
        </h1>
        <div dangerouslySetInnerHTML={{ __html: ticket?.msg! }}></div>
      </div>

      <div className={css.msgs}>
        {ticket?.msgs.map(item => (
          <div className={css.msg}>
            {item.to === 'user' ?
              <img alt="avatar" src={Logo}/>
            :
              <img alt="avatar" src="https://avatars.mds.yandex.net/i?id=e3583305ecf833845bce0d64157b63b5_l-5220445-images-thumbs&n=13" />
            }

            <div className={css.text}>
              <b>{item.to === 'user' ? "Поддержка" : "Вы"} <a className={css.date}>{convertToDate(item.createdAt)}</a></b>
              <p dangerouslySetInnerHTML={{ __html: item?.msg! }}></p>
            </div>
          </div>
        ))}
      </div>
        
      {ticket?.status != 2 &&
        <form className={css.form} onSubmit={handleSubmit}>
          <TinyMceEditor initialValue={message} editorChange={setMessage} type={1} />
          <button type="submit" style={{ width: "100%", background: "#0f51d4", marginTop: 10, padding: 10, color: "#fff" }}>Отправить сообщение</button>
        </form>
      }
    </MainContent>
  )
}